import React, { Component } from 'react';
import Styles from '../../styles/Styles'
import Config from '../../config'

export default class FirstSection extends Component {
  constructor(props) {
   super(props);

    this.state = {
    };
  }

  render() {

    return (
      <div className="section">
        <div className="row">
          <div className="mycol-4 text-center pres-card">
            <i style={Styles.Style.colorMainColor} className="la la-5x la-money"></i>
            <h3 style={Styles.Style.borderBottom}>Des avantages pour vos clients</h3>
            <ul>
              <li>{Config.program.benefit} de leurs achats en coupons de 5€</li>
              <li>10% de remise immédiate sur les produits éligibles à l’occasion de son anniversaire</li>
              <li>Journée de doublement des points chaque semaine</li>
            </ul>
          </div>
          <div className="mycol-4 text-center pres-card">
            <i style={Styles.Style.colorMainColor} className="la la-5x la-envelope"></i>
            <h3 style={Styles.Style.borderBottom}>Le client a ses avantages chez lui</h3>
            <ul>
              <li>5 communications en moyenne par an et par client envoyées par e-mail</li>
              <li>Accès au <a href={Config.program.website}>site internet</a></li>
              <li>Accès à <a href={"https://play.google.com/store/apps/details?id="+Config.program.app}>l'application mobile</a></li>
            </ul>
          </div>
          <div className="mycol-4 text-center pres-card">
            <i style={Styles.Style.colorMainColor} className="la la-5x la-institution"></i>
            <h3 style={Styles.Style.borderBottom}>Conforme à la réglementation</h3>
            <ul>
              <li>N’appartient pas à l’officine</li>
              <li>N’est pas limité à une pharmacie ou un groupement</li>
              <li>N’est pas valable sur les médicaments ou les produits pouvant bénéficier d’une prise en charge</li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/SellingPage/FirstSection.js